import { createSlice, createSelector, lruMemoize } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

interface ExperimentsState {
    deviceId?: string;
    shouldInitAmplitude: boolean | null;
    userProperties: {
        accept?: string;
        acceptLanguage?: string;
        androidAppVersion?: string;
        isAndroidWebview?: boolean;
        userAgent?: string;
    };
}

const initialState = {
    deviceId: undefined,
    shouldInitAmplitude: null,
    userProperties: {},
} satisfies ExperimentsState as ExperimentsState;

const experimentsSlice = createSlice({
    initialState,
    name: 'experiments',
    reducers: {
        experimentEligibilityReceived(state, action: PayloadAction<ExperimentsState>) {
            const {
                deviceId,
                shouldInitAmplitude,
                userProperties,
            } = action.payload;

            state.deviceId = deviceId;
            state.shouldInitAmplitude = shouldInitAmplitude;
            state.userProperties = userProperties;
        },
    },
    selectors: {
        selectExperimentEligibility: createSelector(
            (state: ExperimentsState) => state.deviceId,
            (state: ExperimentsState) => state.shouldInitAmplitude,
            (state: ExperimentsState) => state.userProperties,
            (deviceId, shouldInitAmplitude, userProperties) => ({
                deviceId,
                shouldInitAmplitude,
                userProperties,
            }),
            // The default weakMapMemoize would keep every device id the
            // server has rendered for the life of the process (#1231).
            { memoize: lruMemoize },
        ),
    },
});

export type ExperimentEligibility =
    ReturnType<typeof experimentsSlice.selectors.selectExperimentEligibility>;

export const { actions, selectors } = experimentsSlice;
export const { experimentEligibilityReceived } = actions;
export default experimentsSlice.reducer;
